import { useState,useEffect} from 'react';

const useRWD=()=>{
    const [RWD,setRWD]=useState("mobile");

    const handleRWD=()=>{
        if(window.devicePixelRatio === 1.5 && window.innerWidth>767)
            setRWD("hisesPC");
        else if (window.innerWidth>767)
            setRWD("PC");
        else if (window.innerWidth>575)
            setRWD("tablet");
        else
            setRWD("mobile");
    }

    useEffect(()=>{    
        window.addEventListener('resize',handleRWD);
        handleRWD();         
        return(()=>{
            window.removeEventListener('resize',handleRWD);
        })
    },[]);

    return RWD;
}

export default useRWD;